import React from 'react';
import classNames from 'classnames';
import Icon from '@vtblife/uikit-icons';
import s from './link.module.css';
import { useRel, useVariant } from './utils';
const Link = ({ href, target = 'self', children, variant = 'primary', text: body = true, external = false, onClick, rel: externalRel, gtm, dataTest, visited = false, }) => {
    const variants = useVariant(variant);
    const rel = useRel(externalRel, target);
    return (React.createElement("a", { className: classNames(s.reset, body && s.body, visited && s.visited, ...variants.map(v => s[v])), href: href, target: '_' + target, rel: rel, "data-test": dataTest, "data-gtm": gtm, onClick: onClick },
        children,
        body && external && (React.createElement("span", { className: s.external },
            React.createElement(Icon, { name: "square-arrow", size: "s" })))));
};
export default Link;
//# sourceMappingURL=Link.js.map